import {request, _urlAdvertising} from "../api";
import {ADVERTISING_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetAdvertising = () => {
    const requestData = {
        url: _urlAdvertising,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: ADVERTISING_CONSTS.GET_ADVERTISING,
                    payload: data
                });
            })
    }
};

export const GetAdvertisingById = (id) => {
    const requestData = {
        url: `${_urlAdvertising}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: ADVERTISING_CONSTS.GET_ADVERTISING_BY_ID,
                    payload: res.data
                })
            })
    }
};

export const DeleteAdvertisingById = id => {
    const requestData = {
        url:  `${_urlAdvertising}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: ADVERTISING_CONSTS.DELETE_ADVERTISING_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};

export const CreateAdvertising = data => {
    const requestData = {
        url: _urlAdvertising,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: ADVERTISING_CONSTS.CREATE_ADVERTISING,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ ստեղծվեց!"
                })
                history.push('/advertising')
            })
            .catch(() => {
            })
    }
};

export const UpdateAdvertisingById = (id, data) => {
    const requestData = {
        url: `${_urlAdvertising}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: ADVERTISING_CONSTS.UPDATE_ADVERTISING_BY_ID,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ փոփոխվեց!"
                })
                history.push('/advertising')
            })
            .catch(() => {
            })
    }
};

export const UpdateAdvertisingPositions = items => {
    const requestData = {
        url: _urlAdvertising,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: ADVERTISING_CONSTS.UPDATE_ADVERTISING_POSITIONS
                });
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ թարմացվեց!"
                })
            })
            .catch(() => {
            })
    }
};
